import store from '@/store/index.js';
import cookies from 'vue-cookies';

export default function getToken() {
	let token;

	if (store) {
		token = store.getters['principal/accessToken'];

		if (
			token == undefined ||
			token == null ||
			token == '' ||
			token == 'undefined'
		) {
			token = store.getters['user/userToken'];
		}

		if (!token && store.state.oidcStore) {
			token = store.state.oidcStore.access_token;
		}

		if (!token) {
			token = cookies.get('vue2tkn');
		}
	}

	return token;
}
